import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AuthorsService } from '../shared/authors/authors.service';
import { pgiAuthors } from '../models/authors';
import { CoreService } from '../shared/core/core.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AddNoteAuthorComponent } from '../components/add-note-author/add-note-author.component';
import { PgiNotesAuthor } from '../models/pgiNotesAuthor';
import { UserService } from '../shared/user/user-service.service';
import { User } from '../models/user';

@Component({
  selector: 'app-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.css']
})
export class AuthorsComponent implements OnInit {
  static authors: pgiAuthors[];
  selectedRowIndex = -1;
  displayedColumns = ['id', 'authorName', 'notes', 'notes2', 'archiwalny', 'action'];
  dataSource: any;
  userRole = [];
  isLoading = false;
  isDisable = true;
  color = 'primary';
  mode = 'indeterminate';

  notes = '';
  pgiNotesAuthor: PgiNotesAuthor = { id: 0, notes: ''};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private authorService: AuthorsService,
    private userService: UserService,
    private core: CoreService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar) {

    }

  ngOnInit() {
    this.getAuthors();
    this.checkRole();
  }

  getAuthors(): void {
    this.isLoading = true;
    this.authorService.getAuthors().subscribe((authors => {
      authors = authors;
      this.dataSource = new MatTableDataSource();
      this.dataSource.data = authors;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.GetNotesForAllAuthors();
      this.GetUserRole();

      this.isLoading = false;
    }) );
  }

  goBack(): void {
    this.core.goBack();
  }

  highlight(row) {
    this.selectedRowIndex = row.id;
}
applyFilter(filterValue: string) {
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

openDialog(row): void {
  this.selectedRowIndex = row;
  const dialogRef = this.dialog.open(AddNoteAuthorComponent, {
    width: '80%',
    data: this.selectedRowIndex
  });

  dialogRef.afterClosed().subscribe(result => {
   if (result !== undefined) {
    console.log('result changes');
    console.log(result);
    this.save(result);
   }
  });
}

checkRole(): void {
  const res = this.userRole.find(r => r === 'Administrator') != null;
  console.log(this.userRole);
  if (res) {
    this.isDisable = false;
  } else {
    this.isDisable = true;
  }
}

GetUserRole() {
  this.userService.getUserClaimsRole().subscribe((data: any) => {
    this.userRole = data;
    this.checkRole();
    console.log(this.isDisable);
  });
}


save(author) {
  this.authorService.updateAuthor(author).subscribe(
    success => {
   this.openSnackBar('Zaktualizowano poprawnie dane dla '  + author.authorName, '');
 },
    error => this.openSnackBar('Problem z modyfikacja opisu dla '  + author.authorName, '')
   );
}

openSnackBar(message: string, action: string) {
  this.snackBar.open(message, action, {
    duration: 2000,
    verticalPosition: 'top',
  });
}

saveNotes(): void {
this.authorService.addNotesForAll(this.pgiNotesAuthor).subscribe(
  success => {
    console.log('success');
    console.log(success);
    this.openSnackBar('Opis dodany poprawnie', '');
  },
     error => { this.openSnackBar('Problem z dodaniem opisu', '');
     console.log('error');
     console.log(error);
}
     );
}

GetNotesForAllAuthors() {
  this.authorService.getNotes().subscribe(result => {
    if (result != null) {
      this.pgiNotesAuthor = result;
    }
    });
}

archiwizuj(): void {

  const source = this.dataSource.data; // .filter(x => x.archiwalny === true);

  this.authorService.updateAuthors(source).subscribe(
    success => {
      console.log('success archiwizacja');
      console.log(success);
      this.getAuthors();

      this.openSnackBar('Zarchiwizowano zaznaczonych autorów', '');
    },
       error => { this.openSnackBar('Problem z archiwizacją', '');
       console.log('error');
       console.log(error);
  }
  );
}

}
